import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider, signInWithPopup} from "firebase/auth";
import {getFirestore} from "firebase/firestore"

const firebaseConfig = {
    apiKey: "AIzaSyBoUN4_PMCpQLRIM99UahrRIog1VtSdEJs",
    authDomain: "winaxfinancial.firebaseapp.com",
    projectId: "winaxfinancial",
    storageBucket: "winaxfinancial.appspot.com",
    messagingSenderId: "402104144493",
    appId: "1:402104144493:web:d59e6152abe2516aff2564",
    measurementId: "G-K9MPR80DK0"
  };




const firebaseApp = initializeApp(firebaseConfig);
const auth = getAuth(firebaseApp);
const db = getFirestore(firebaseApp)
var provider = new GoogleAuthProvider(auth);

export {auth, provider, signInWithPopup};

export default db